import makeStyles from '@material-ui/core/styles/makeStyles'
import TableHeaderRow from '../../2compounds/Tables/TableHeaderRow'
import TableHeaderCell from '../../2compounds/Tables/TableHeaderCell'
import TableGridDiv from '../../2compounds/Tables/TableGridDiv'
import TableBody from '../../2compounds/Tables/TableBody'
import TableBodyCell from '../../2compounds/Tables/TableBodyCell'
import TableBodyRow from '../../2compounds/Tables/TableBodyRow'
import { translateImportStatus, translateImportType } from '../../../services/util/miscellaneousService'
import React, { useContext } from 'react'
import DetailButton from '../../2compounds/DetailButton'
import { useNavigate } from 'react-router-dom'
import { GenericErrorBoundary } from '../../2compounds/GenericErrorBoundary'
import {
  formatContactInputFromId,
  formatNewClientData,
  formatNewLocationData,
  formatServiceInputFromId
} from '../../../services/util/formatter'
import { GlobalContext } from '../../../services/context/DataContext'
import { removeAllItemsInSessionStorage, setItemToSessionStorage } from '../../../services/util/sessionStorageManager'
import dayjs from 'dayjs'
import ApiService from '../../../common/ApiCalls'

const useStyles = makeStyles({
  root: {
    margin: '8px 0'
  },
  nameColumn: {
    display: (columns) => !columns[0].isShown && 'none'
  },
  statusColumn: {
    display: (columns) => !columns[1].isShown && 'none'
  },
  dateColumn: {
    display: (columns) => !columns[2].isShown && 'none'
  }
})

const DataRecordStatusTable = ({ recordStatusData }) => {
  const navigate = useNavigate()
  const userId = localStorage.getItem('userId')
  const { activeTabData, smartFormSideTab, approvalStatusRecordTable } = useContext(GlobalContext)
  const [, setActiveTab] = activeTabData
  const [, setSelectedTab] = smartFormSideTab
  const [approvalStatusRecordTableFilter] = approvalStatusRecordTable
  const classes = useStyles(approvalStatusRecordTableFilter)

  const columns = [
    { label: 'Action', position: 'span 3', className: classes.nameColumn },
    { label: 'Submitted by', position: 'span 2', className: classes.nameColumn },
    { label: 'Date', position: 'span 2', className: classes.dateColumn },
    { label: 'Approver', position: 'span 2', className: classes.nameColumn },
    { label: 'Status', position: 'span 2', className: classes.statusColumn },
    { label: 'More', position: 'span 1', className: '' }
  ]

  const pathHandler = (name, status, id) => {
    switch (name) {
      case 'New Service': {
        return `/approveService/location/${id}`
      }
      case 'New Contact': {
        return `/approvePeople/location/${id}`
      }
      case 'New Location': {
        return `/approveLocation/client/${id}`
      }
      case 'New Client': {
        return `/approveClient/client/${id}`
      }
      case 'Add Comment':
      case 'Edit Comment':
      case 'Delete Comment':
      case 'Add Dashboard Metrics':
      case 'Edit Dashboard Metrics':
      case 'Delete Dashboard Metrics': {
        return `/approveDashboard/${id}`
      }
      case 'Add Feedback':
      case 'Edit Feedback':
      case 'Delete Feedback': {
        return `/approveDashboard/feedback/${id}`
      }
      default:
    }
  }

  const detailButtonHandler = async (path, importId, name, status) => {
    switch (name) {
      case 'New Service': {
        await formatServiceInputFromId(importId)
        if (status === 'Pending Approval') {
          navigate(path)
        } else if (status === 'Rejected') {
          setActiveTab('Import')
          // setSelectedOptionItem('Location')
          setSelectedTab(3)
        }
        break
      }
      case 'New Contact': {
        await formatContactInputFromId(importId)
        if (status === 'Pending Approval') {
          navigate(path)
        } else if (status === 'Rejected') {
          setItemToSessionStorage('importType', 'Add new/assign existing contact')
          setActiveTab('Create New ')
          setSelectedTab(2)
        }
        break
      }
      case 'New Location': {
        await formatNewLocationData(importId)
        if (status === 'Pending Approval') {
          navigate(path)
        } else if (status === 'Rejected') {
          setItemToSessionStorage('importType', 'Add one location')
          setActiveTab('Create New ')
          setSelectedTab(1)
        }
        break
      }
      case 'New Client': {
        await formatNewClientData(importId)
        if (status === 'Pending Approval') {
          navigate(path)
        } else if (status === 'Rejected') {
          setActiveTab('Create New ')
          setSelectedTab(0)
        }
        break
      }
      case 'Add Comment': {
        removeAllItemsInSessionStorage()
        const comment = await ApiService().getPendingDashboardData(importId)
        localStorage.setItem('locId', comment.comment_data.id)
        setItemToSessionStorage('addComment', comment)
        setItemToSessionStorage('initiatorEmail', comment.initiator_email)
        if (status === 'Rejected') {
          setItemToSessionStorage('rejected', true)
        }
        navigate(path)
        break
      }
      case 'Edit Comment': {
        removeAllItemsInSessionStorage()
        const comment = await ApiService().getPendingDashboardData(importId)
        localStorage.setItem('locId', comment.comment_data.id)
        setItemToSessionStorage('editComment', comment)
        setItemToSessionStorage('initiatorEmail', comment.initiator_email)
        if (status === 'Rejected') {
          setItemToSessionStorage('rejected', true)
        }
        navigate(path)
        break
      }
      case 'Delete Comment': {
        removeAllItemsInSessionStorage()
        const comment = await ApiService().getPendingDashboardData(importId)
        localStorage.setItem('locId', comment.comment_data.id)
        setItemToSessionStorage('deleteComment', comment)
        setItemToSessionStorage('initiatorEmail', comment.initiator_email)
        navigate(path)
        break
      }
      case 'Add Dashboard Metrics': {
        removeAllItemsInSessionStorage()
        const dashboardMetrics = await ApiService().getPendingDashboardData(importId)
        localStorage.setItem('locId', dashboardMetrics.dashboard_data.id)
        setItemToSessionStorage('addDashboardMetrics', dashboardMetrics)
        setItemToSessionStorage('initiatorEmail', dashboardMetrics.initiator_email)
        if (status === 'Rejected') {
          setItemToSessionStorage('rejected', true)
        }
        navigate(path)
        break
      }
      case 'Edit Dashboard Metrics': {
        const dashboardMetrics = await ApiService().getPendingDashboardData(importId)
        localStorage.setItem('locId', dashboardMetrics.dashboard_data.id)
        setItemToSessionStorage('editDashboardMetrics', dashboardMetrics)
        setItemToSessionStorage('initiatorEmail', dashboardMetrics.initiator_email)
        if (status === 'Rejected') {
          setItemToSessionStorage('rejected', true)
        }
        navigate(path)
        break
      }
      case 'Delete Dashboard Metrics': {
        const dashboardMetrics = await ApiService().getPendingDashboardData(importId)
        localStorage.setItem('locId', dashboardMetrics.dashboard_data.id)
        setItemToSessionStorage('deleteDashboardMetrics', dashboardMetrics)
        setItemToSessionStorage('initiatorEmail', dashboardMetrics.initiator_email)
        navigate(path)
        break
      }
      case 'Add Feedback':
      case 'Edit Feedback':
      case 'Delete Feedback': {
        navigate(path)
        break
      }
      default:
    }
  }

  const sortFunction = async (query) => {
    console.log(query)
  }

  return (
    <div className={classes.root}>
      <TableGridDiv>
        {/*  Table Header  */}
        <TableHeaderRow>
          {columns.map((column) => (
            <TableHeaderCell
              gridColumn={column.position}
              key={column.label}
              label={column.label}
              variant={column.label === 'More' && 'More'}
              className={column.className}
              onSort={sortFunction}
            />
          ))}
        </TableHeaderRow>
        {/*  Table Body  */}
        <GenericErrorBoundary>
          <TableBody>
            {recordStatusData.map((recordStatus) => {
              const translatedImportType = translateImportType(recordStatus.name)
              const translatedImportStatus = translateImportStatus(recordStatus.status)
              const importId = recordStatus.id
              const path = pathHandler(translatedImportType, translatedImportStatus, importId)
              const formattedDateTime = dayjs(recordStatus.created_at).format('YYYY-MM-DD | HH:mm')
              const isFeedbackRequest = translatedImportType.endsWith('Feedback')
              const isMoreButtonDisabled = !isFeedbackRequest && translatedImportStatus !== 'Rejected' && recordStatus.approverId !== userId
              return (
                <TableBodyRow
                  isOpen
                  key={recordStatus.id}
                >
                  <TableBodyCell gridColumn={columns[0].position} className={classes.nameColumn}>
                    {translatedImportType}
                  </TableBodyCell>
                  <TableBodyCell gridColumn={columns[1].position} className={classes.nameColumn}>
                    {recordStatus.initiator_name || ''}
                  </TableBodyCell>
                  <TableBodyCell gridColumn={columns[2].position} className={classes.dateColumn}>
                    {formattedDateTime}
                  </TableBodyCell>
                  <TableBodyCell gridColumn={columns[3].position} className={classes.nameColumn}>
                    {recordStatus.approver_name || ''}
                  </TableBodyCell>
                  <TableBodyCell gridColumn={columns[4].position} className={classes.statusColumn}>
                    {translatedImportStatus}
                  </TableBodyCell>
                  <TableBodyCell gridColumn={columns[5].position}>
                    <DetailButton
                      disabled={isMoreButtonDisabled}
                      onClick={() => detailButtonHandler(path, importId, translatedImportType, translatedImportStatus)}
                    />
                  </TableBodyCell>
                </TableBodyRow>
              )
            })}
          </TableBody>
        </GenericErrorBoundary>
      </TableGridDiv>
    </div>
  )
}

export default DataRecordStatusTable
